import styled from "styled-components"
import { ReactComponent as GearIcon } from "images/icons/gear.svg"
import { ReactComponent as Check } from "images/icons/square-check.svg"
import { ReactComponent as Xmark } from "images/icons/square-xmark.svg"
import { theme } from "../../theme"
import {ReactComponent as Arrow} from "images/icons/arrow-right.svg"

type StyledProps = {
  $color: string
}


export const OperationWrapper = styled.div<StyledProps>`
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.5rem;
  padding: 1rem;
  background: ${(p) => p.theme.colors.background};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  border-left: ${p => `0.2rem solid ${p.$color}`};
`
export const Info = styled.div`
  display: flex;
  flex-direction: column;
`

export const OperationData = styled.div`
  color: ${(p) => p.theme.colors.greyDarker};
  font-size: 1.1rem;
  line-height: 1.4rem;
display: flex;
  align-items: center;
  margin-bottom: 0.2rem;

  svg {
    height: 1.2rem;
    margin-right: 1rem;
  }
`

export const OperationType = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  margin: 0.5rem 0 1rem 0;

  svg {
    fill: ${(p) => p.$color};
    height: 1.4rem;
    margin-right: 1rem;
    stroke-width: 2;
    filter: saturate(0.8) brightness(1.05);
    vertical-align: middle;
    position: relative;
    top: 0;
  }
`

export const Icon = styled(GearIcon)`
  height: 1.8rem;
  fill: ${(p) => p.theme.colors.greyDark};
  &:hover {
    fill: ${(p) => p.theme.colors.grey};
    cursor: pointer;
  }
  margin-right: 1rem;
`

export const FilterContainer = styled.div`
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.6rem;
  padding: 1rem;
  background: #f0f3f7;
  margin-bottom: 3rem;
`

export const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`

export const OperationButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 1rem;

  ${theme.mQ.MEDIA_MIN_LARGE} {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
`

export const OperationButton = styled.div`
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.6rem;
  background: ${(p) => p.theme.colors.white};
  padding: 1rem;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
    background: ${(p) => p.theme.colors.background};
  }
`

export const CheckIcon = styled(Check)`
  height: 1.6rem;
  fill: ${(p) => p.theme.colors.success.background};
  margin-right: 1rem;
`

export const XmarkIcon = styled(Xmark)`
  height: 1.6rem;
  fill: ${(p) => p.theme.colors.error.background};
  margin-right: 1rem;
`

export const OrderLineRow = styled.div`
border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.6rem;
  padding: 1rem;
  background: ${(p) => p.theme.colors.background};
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;

  img {
    height: 3rem;
  }
`

export const OrderLabel = styled.h2`
  display: flex;
  align-items: center;
  margin: 3rem 0;
`

export const ArrowIcon = styled(Arrow)`
height: 1.6rem;
margin-left: 1rem;
  transition: rotate 0.3s ease-in-out;
  &:hover {
    rotate: -40deg;
    cursor: pointer;
  }
`

export const OrderLineInfoWrapper = styled.div`
display: flex;
align-items: center;

  svg {
    height: 3rem;
    margin: 0 0.5rem;
  }
`

export const ProductNameWrapper = styled.div`
display: flex;
  flex-direction: column;
  margin-left: 2rem;
`

export const OrderTotal = styled.div`
  padding: 2rem 0;
  position: relative;
  background: ${(p) => p.theme.colors.turquoiseLighter};
  border: 0.1rem solid ${(p) => p.theme.colors.turquoiseBorder};
  border-radius: 0.5rem;
  margin: 2rem 0;
  display: flex;
  justify-content: space-between;

  div {
    font-weight: 700;
    padding: 0 2.5rem;
  }
`
